import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

import useAuth from '../hooks/useAuth'
import OrbitSession from '../hooks/useCookies'
import PermissionedRoute from '../pages/PermissionedRoute'

import ClientApp from './ClientApp'
import VendorApp from './VendorApp'

function DemoApp() {
  const { setAuth } = useAuth()

  useEffect(() => {
    setAuth({ role: [OrbitSession.get('role')] })
  }, [])

  return (
    <Routes>
      <Route path='/'>
        <Route
          element={<PermissionedRoute allowedRoles={['owner', 'admin']} />}
        >
          <Route path='app/*' element={<ClientApp />} />
        </Route>
        <Route
          element={<PermissionedRoute allowedRoles={['ops', 'opsowner']} />}
        >
          <Route path='hq/*' element={<VendorApp />} />
        </Route>
      </Route>
    </Routes>
  )
}

DemoApp.propTypes = {}

export default DemoApp
